import React, { Component } from "react";
import { StyleSheet, css } from "aphrodite";
import firebase from "firebase";
import {
  Button,
  Modal,
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock
} from "react-bootstrap";
import { connect } from "react-redux";
import { PromoChange } from "../../redux/actions/modal";
import {
  Titulo,
  Conteudo,
  Img,
  Link,
  Valor,
  Promocao,
  Editar
} from "../../redux/actions/promo";
class EditPromo extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      modal: false,
      oldImg: ""
    };
  }
  toggle() {
    this.setState({ modal: !this.state.modal });
  }
  componentWillMount() {
    this.getData();
  }
  getData() {
    firebase.auth().onAuthStateChanged(user => {
      var id = user.uid;
      firebase
        .database()
        .ref(`promocoes/${id}/${this.props.id}`)
        .orderByKey()
        .on("value", snapshot => {
          this.props.Titulo(snapshot.child("nome").val());
          this.props.Conteudo(snapshot.child("conteudo").val());
          this.props.Valor(snapshot.child("valor").val());
          this.props.Promocao(snapshot.child("promocao").val());
          this.props.Link(snapshot.child("link").val());
          this.setState({ oldImg: snapshot.child("img").val() });
        });
    });
  }
  render() {
    return (
      <div>
        <Button onClick={() => this.toggle()} bsStyle="success">
          Editar
        </Button>
        <Modal show={this.state.modal} onHide={() => this.toggle()}>
          <Modal.Header closeButton>
            <Modal.Title>Editar</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FieldGroup
              id="formControlsText"
              type="text"
              label="Título"
              placeholder="Ex: Promoção Imperdivel"
              onChange={e => this.props.Titulo(e.target.value)}
              value={this.props.title}
            />
            <FormGroup
              controlId="formControlsTextarea"
              onChange={e => this.props.Conteudo(e.target.value)}
              value={this.props.content}
            >
              <ControlLabel>Descrição do Produto / Serviço</ControlLabel>
              <FormControl
                componentClass="textarea"
                value={this.props.content}
                placeholder="Digite aqui um texto de até 120 Caracteres."
              />
            </FormGroup>
            <FieldGroup
              id="formControlsFile"
              type="file"
              label="Imagem"
              help="Imagem de destaque para a promoção."
              onChange={e => this.props.Img(e)}
            />
            {this.props.sendState}
            <FieldGroup
              id="formControlsText"
              type="number"
              label="Valor Habitual"
              placeholder="Ex: 30.00"
              onChange={e => this.props.Valor(e.target.value)}
              value={this.props.valor}
            />
            <FieldGroup
              id="formControlsText"
              type="number"
              label="Valor Promocional"
              placeholder="Ex: 15.00"
              onChange={e => this.props.Promocao(e.target.value)}
              value={this.props.Vpromo}
            />
            <ControlLabel>
              Obs: A promoção tem o prazo de validade de 7 dias, após esse
              período a promoção expirará. Mas você poderá cadastrar uma nova =)
            </ControlLabel>
            <FieldGroup
              className={css(styles.linkpromo)}
              id="formControlsText"
              type="text"
              label=""
              placeholder="Link da promoção"
              onChange={e => this.props.Link(e.target.value)}
              value={this.props.link}
            />
          </Modal.Body>
          <Modal.Footer>
            {this.props.sendState}
            <Button
              bsStyle="success"
              onClick={() => {
                this.props.Editar(
                  this.props.content,
                  this.props.title,
                  this.props.Vpromo,
                  this.props.valor,
                  this.props.user.email,
                  this.props.img,
                  this.props.link,
                  7,
                  this.props.id,
                  this.state.oldImg
                );
              }}
            >
              Enviar
            </Button>
            <Button onClick={() => this.toggle()}>Cancelar</Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

const styles = StyleSheet.create({
  linkpromo: {
    display: "none"
  }
});
const mapStateToProps = state => {
  return {
    promo: state.modal.promo,
    title: state.promo.title,
    content: state.promo.content,
    img: state.promo.img,
    imgError: state.promo.imgError,
    link: state.promo.link,
    valor: state.promo.valor,
    Vpromo: state.promo.Vpromo,
    sendState: state.promo.sendState,
    user: state.user.user
  };
};
function FieldGroup({ id, label, help, ...props }) {
  return (
    <FormGroup controlId={id}>
      <ControlLabel>{label}</ControlLabel>
      <FormControl {...props} />
      {help && <HelpBlock>{help}</HelpBlock>}
    </FormGroup>
  );
}
export default connect(
  mapStateToProps,
  { PromoChange, Titulo, Conteudo, Img, Link, Valor, Promocao, Editar }
)(EditPromo);



// WEBPACK FOOTER //
// ./src/assets/modalEditarPromo/index.js